import {Injectable} from '@angular/core';
import {HttpEvent, HttpEventType, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {defer, finalize, Observable, tap} from 'rxjs';
import {FileUploadService} from '../_services/file-upload.service';
import {isFileUploadRequest} from '../_util/file-upload-limits';

/**
 * Reports progress of requests that send files together with a save, so the app can block interaction and show
 * the progress (see FileUploadService). Requests that already ask for progress events themselves (the Files tabs,
 * which upload right after selection and show progress per file) are left as they are.
 */
@Injectable()
export class UploadProgressInterceptor implements HttpInterceptor {
  constructor(private fileUploadService: FileUploadService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.reportProgress || !isFileUploadRequest(request)) {
      return next.handle(request);
    }

    return defer(() => {
      const startedAt = Date.now();
      this.fileUploadService.start();

      // HttpClient still hands only the response to callers that observe the body, progress events stay here
      return next.handle(request.clone({reportProgress: true})).pipe(
        tap(event => {
          if (event.type === HttpEventType.UploadProgress && event.total) {
            this.fileUploadService.reportProgress(event.loaded, event.total, startedAt);
          }
        }),
        finalize(() => this.fileUploadService.finish())
      );
    });
  }
}
